import ApontamentoEntidadeEvent from "@/domain/events/apontamentoEntidade.event";
import {reactive} from "vue";

class SinistroEvents {

    apontamentoEvent = new ApontamentoEntidadeEvent()

    listenerSinistroGravado = reactive({value: {sinistroId: ''}})
    listenerSinistroAlterado = reactive({value: {sinistroId: ''}})

    emitSinistroGravado(sinistroId: string) {
        this.listenerSinistroGravado.value = {sinistroId: sinistroId}
    }

    emitSinistroAlterado(sinistroId: string) {
        this.listenerSinistroAlterado.value = {sinistroId: sinistroId}
    }

}

export default SinistroEvents;